import React from 'react';
import PropTypes from 'prop-types';
import {get} from './Storage';
import axios from 'axios';
import {ClassName} from 'mgToolsKit';
import * as Colors  from 'material-ui/styles/colors';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'UPageComponent';

var styles = AppSettings.styles;

var primaryColor = AppSettings.theme.primarycolor;

class UPage extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            opened: props.opened
        };

        this.handlerClose = this.handlerClose.bind(this);
    }

    componentDidMount() {
        
    }

    componentWillReceiveProps(props) {
        var state = this.state;
        if(props['opened'] != undefined){
            state.opened = props['opened'];
        }

        if(props['title'] != undefined){
            state.title = props['title'];
        }
        if(state.length > 0){
            this.setState(state);
        }
    }

    handlerClose(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            opened: !this.state.opened
        });
        if(this.props.onCloseAction != undefined){
            this.props.onCloseAction();
        }
    }

    render() {
        var _className = ["userbox-upage", "animated", "bounceInRight"];
        if(!this.state.opened){
            //_className.push("userbox-upage-opened");
            return null;
        }

        var _styleHeader = {
            borderColor: primaryColor,
            color: AppSettings['baseTheme'].palette.textColor,
            backgroundColor: styles['mgCardStyle']['background'] 
        }

        var _style = {
            backgroundColor: AppSettings['baseTheme'].palette.canvasColor,
            color: AppSettings['baseTheme'].palette.textColor
        };

        return (
            <div style={_style} className={ClassName(_className)}>
                <div style={_styleHeader} className="userbox-upage-header">
                    <a href="#" onClick={this.handlerClose}><i  className="fa-mg fa-mg-chevron-left"></i></a>
                    <span>{this.props.title}</span>
                </div>
                <div className="userbox-upage-body">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

UPage.displayName = componentName;

// PropTypes validation
UPage.propTypes = {
    title: PropTypes.string.isRequired,
    opened: PropTypes.bool,
    onCloseAction: PropTypes.func
};

// default props
UPage.defaultProps = {
    opened:false
};

// contextTypes validation
UPage.contextTypes = {
}

export default  UPage;